import React, { useEffect, useRef, useState } from 'react';
import { FaCheck, FaPlus, FaRegFilePdf, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select'

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { Image, pdf } from '@react-pdf/renderer';
// import ReactPDF, { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';

import { Container, Row, Col, Form, Button, ListGroup, Card, Table } from 'react-bootstrap';
import './POvsMR.css';

const Stock = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const id = user ? user.id : null;
    console.log(id)



    const [currentDate, setCurrentDate] = useState('');


    useEffect(() => {
        const date = new Date();
        const formattedDate = date.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
    }, []);



    const toggleModal = () => setIsModalOpen(!isModalOpen);






    const handleSave = (id) => {

    };

    const handleSubmit = (id) => {

    };

    const handleApprove = (id) => {

    };

    const handleRefresh = () => {

    };

    const [showEditformm, setShowEditFormm] = useState(false);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [showViewForm, setShowViewForm] = useState(false);





    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    const [formMode, setFormMode] = useState('');
    // const userPermissions = user ? {
    //     add: user.add_permission,
    //     edit: user.edit_permission,
    //     view: user.view_permission,
    //     save: user.save_permission,
    //     approve: user.approve_permission,
    //     print: user.print_permission,
    //     close: user.close_permission,
    //     clear: user.clear_screen_permission
    // } : {};
    const userPermissions = user && user.permissions && user.permissions[1000]
        ? {
            add: user.permissions[3000].sub_ids[3004]?.permissions.add_permission || 0,
            edit: user.permissions[3000].sub_ids[3004]?.permissions.edit_permission || 0,
            view: user.permissions[3000].sub_ids[3004]?.permissions.view_permission || 0,
            save: user.permissions[3000].sub_ids[3004]?.permissions.save_permission || 0,
            approve: user.permissions[3000].sub_ids[3004]?.permissions.approve_permission || 0,
            print: user.permissions[3000].sub_ids[3004]?.permissions.print_permission || 0,
            close: user.permissions[3000].sub_ids[3004]?.permissions.exit_permission || 0,
            clear: user.permissions[3000].sub_ids[3004]?.permissions.refresh_permission || 0
        }
        : {};


    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };

    const [items, setItems] = useState([]);
    const [indents, setIndents] = useState([]);
    const [combinedData, setCombinedData] = useState([]);
    const [ALLData, setAllData] = useState([]);
    const [selectedData, setSelectedData] = useState(null); // State for dropdown selection

    // Function to format date to YYYY-MM-DD
    // const formatDateToDateInput = (date) => {
    //     const dateObj = new Date(date);
    //     const year = dateObj.getFullYear();
    //     const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    //     const day = dateObj.getDate().toString().padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // };
    const formatDateToDateInput = (date) => {
        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) {
            return 'Invalid Date'; // Return an invalid message if the date is not valid
        }
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [poList, setPoList] = useState(['']);

    const [supplierList, setSupplierList] = useState([]); // Supplier data

    const [supplierFilter, setSupplierFilter] = useState(null);

    console.log(supplierList)

    const getSupplierName = (supp_id) => {
        const supplier = supplierList.find(s => s.Supp_cd === supp_id);
        return supplier ? supplier.Supp_Nm : 'Unknown Supplier'; // Return supplier name or 'Unknown Supplier' if not found
    };


    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);


    const [data, setData] = useState({ MRN: [], MI: [], ItemOpeningBalance: [], WOR_DTL: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [itemms, setItemms] = useState([]);

    const fetchItems = async () => {
        try {
            const response = await fetch('https://erpapi.emedha.in/pages/api/api/itemsmasterform');
            if (!response.ok) {
                throw new Error('Failed to fetch items');
            }
            const data = await response.json();
            setItemms(data);
        } catch (err) {
            console.error('Error fetching items:', err.message);
        }
    };
    console.log(itemms)

    const fetchData = () => {
        axios
            .get('https://erpapi.emedha.in/pages/api/getMRNMIData') // API endpoint
            .then((results) => {
                setData(results.data); // Set the data in the state
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setError('Failed to load data');
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
        fetchItems();
        fetchOpenBalances();
    }, []);

    console.log(data)

    const [openBalanceData, setOpenBalanceData] = useState([]);

    useEffect(() => {
        if (fromDate && toDate) {
            fetchOpenBalances();
        }
    }, [fromDate, toDate]);

    function formatDateToDateInputt(date) {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const fetchOpenBalances = () => {
        if (!fromDate || !toDate) return;



        const formattedFromDate = formatDateToDateInputt(fromDate);
        const formattedToDate = formatDateToDateInputt(toDate);
        console.log('this is from date ', formattedFromDate);
        console.log('this is to date', formattedToDate)
        axios.post('https://erpapi.emedha.in/pages/api/get-open-balance22', {
            fromDate: formattedFromDate,
            toDate: formattedToDate
        })
            .then((response) => {
                setOpenBalanceData(response.data);
            })
            .catch((error) => {
                console.error('Error fetching open balance data:', error);
            });
    };



    console.log('this is open balance', openBalanceData)
    const filterByDateRange = (mrnData, miData, ItemOpeningBalance, WOR_DTL, fromDate, toDate) => {
        if (!fromDate || !toDate) return { mrnData: [], miData: [], ItemOpeningBalance: [], WOR_DTL: [] }; // If no date range selected, return empty data

        const fromDateObj = new Date(fromDate);
        const toDateObj = new Date(toDate);
        fromDateObj.setHours(0, 0, 0, 0);

        toDateObj.setHours(23, 59, 59, 999);

        // Filter MRN data by date range
        const filteredMRN = mrnData.filter(item => {
            const indentDate = new Date(item.MRN_Dt);
            return indentDate >= fromDateObj && indentDate <= toDateObj;
        });

        // Filter MI data by date range
        const filteredMI = miData.filter(item => {
            const indentDate = new Date(item.MI_DT);
            return indentDate >= fromDateObj && indentDate <= toDateObj;
        });

        const filteredBalance = ItemOpeningBalance.filter(item => {
            const indentDate = new Date(item.date);
            return indentDate <= fromDateObj;
        });

        const WOR_DTL_QTY = WOR_DTL.filter(item => {
            const indentDate = new Date(item.Entry_Date);
            // return indentDate <= fromDateObj;
            return indentDate >= fromDateObj && indentDate <= toDateObj;
        });

        return { mrnData: filteredMRN, miData: filteredMI, ItemOpeningBalance: filteredBalance, WOR_DTL: WOR_DTL_QTY };
    };


    //const filteredData = filterByDateRange(data);
    // const groupedData = Object.values(groupAndSumData(filteredData));

    const filteredALLData = filterByDateRange(data);

    const groupAndSumData = (mrnData, miData, ItemOpeningBalance, WOR_DTL) => {
        // Check if the data arrays are valid and not undefined
        if (!Array.isArray(mrnData) || !Array.isArray(miData) || !Array.isArray(ItemOpeningBalance) || !Array.isArray(WOR_DTL)) {
            console.error('Invalid data provided to groupAndSumData');
            return [];
        }

        // Step 1: Group MRN data by Item_cd and sum the Accepted_qty
        const mrnGrouped = mrnData.reduce((acc, item) => {
            if (!acc[item.Item_cd]) {
                acc[item.Item_cd] = {
                    Item_cd: item.Item_cd,
                    totalAcceptedQty: 0,
                };
            }
            acc[item.Item_cd].totalAcceptedQty += item.Accepted_qty;
            return acc;
        }, {});

        // Step 2: Group MI data by Item_code and sum the Issue_QTY
        const miGrouped = miData.reduce((acc, item) => {
            if (!acc[item.Item_code]) {
                acc[item.Item_code] = {
                    Item_code: item.Item_code,
                    totalIssueQty: 0,
                };
            }
            acc[item.Item_code].totalIssueQty += item.Issue_QTY;
            return acc;
        }, {});

        // Step 3: Group Opening Balance by Item_code and sum the quantities
        const balanceGrouped = ItemOpeningBalance.reduce((acc, item) => {
            if (!acc[item.item_code]) {
                acc[item.item_code] = {
                    item_code: item.item_code,
                    qty: 0,
                    Main_Group_CD: item.Main_Grp,
                    Main_Group_Desc: item.Main_Grp_Desc,
                    Sub_Group_CD: item.Sub_Grp,
                    Sub_Group_Desc: item.Sub_Grp_Desc,
                };
            }
            acc[item.item_code].qty += item.qty;
            return acc;
        }, {});

        const WOR_DTLQTY = WOR_DTL.reduce((acc, item) => {
            if (!acc[item.Item_Code]) {
                acc[item.Item_Code] = {
                    Item_Code: item.Item_Code,
                    total_wo_qty: 0,
                    // Main_Group_CD: item.Main_Group_CD,
                    // Main_Group_Desc: item.Main_Group_Desc,
                    // Sub_Group_CD: item.Sub_Group_CD,
                    // Sub_Group_Desc: item.Sub_Group_Desc,
                };
            }
            acc[item.Item_Code].total_wo_qty += item.QTY;
            return acc;
        }, {});


        // Step 4: Combine the data from MRN, MI, and Opening Balance
        // const mergedData = Object.keys(mrnGrouped).map(key => {
        //     const mrnItem = mrnGrouped[key];
        //     const miItem = miGrouped[key] || { totalIssueQty: 0 };
        //     const balanceItem = balanceGrouped[key] || { qty: 0 };
        //     const qtyItem = WOR_DTLQTY[key] || { total_wo_qty: 0 };

        //     // Calculate Balance Stock
        //     const balanceStock = balanceItem.qty + mrnItem.totalAcceptedQty + qtyItem.total_wo_qty - miItem.totalIssueQty;

        //     return {
        //         Item_cd: mrnItem.Item_cd,
        //         openBalance: balanceItem.qty,
        //         materialRequest: mrnItem.totalAcceptedQty,
        //         materialIssue: miItem.totalIssueQty,
        //         balanceStock: balanceStock,
        //         // wor_dtl_qty: qtyItem
        //         wor_dtl_qty: qtyItem.total_wo_qty,
        //     };
        // });

        const allItemCodes = new Set([
            ...mrnData.map(i => i.Item_cd),
            ...miData.map(i => i.Item_code),
            ...ItemOpeningBalance.map(i => i.item_code),
            ...WOR_DTL.map(i => i.Item_Code)
        ]);
        const mergedData = Array.from(allItemCodes).map(code => {
            const mrnItem = mrnGrouped[code] || { totalAcceptedQty: 0 };
            const miItem = miGrouped[code] || { totalIssueQty: 0 };
            const balanceItem = balanceGrouped[code] || {
                qty: 0,
                Main_Group_CD: null,
                Main_Group_Desc: null,
                Sub_Group_CD: null,
                Sub_Group_Desc: null,

            };
            const qtyItem = WOR_DTLQTY[code] || {
                total_wo_qty: 0,
                // Main_Group_CD: null,
                // Main_Group_Desc: null,
                // Sub_Group_CD: null,
                // Sub_Group_Desc: null,
            };

            const balanceStock = balanceItem.qty + mrnItem.totalAcceptedQty + qtyItem.total_wo_qty - miItem.totalIssueQty;

            return {
                Item_cd: code,
                openBalance: balanceItem.qty,
                materialRequest: mrnItem.totalAcceptedQty,
                materialIssue: miItem.totalIssueQty,
                wor_dtl_qty: qtyItem.total_wo_qty,
                balanceStock,
                Main_Group_CD: balanceItem.Main_Group_CD,
                Main_Group_Desc: balanceItem.Main_Group_Desc,
                Sub_Group_CD: balanceItem.Sub_Group_CD,
                Sub_Group_Desc: balanceItem.Sub_Group_Desc,
            };
        });

        console.log("Grouped Items:", mergedData);

        return mergedData;
    };




    const groupAndSumDataa = (mrnData, miData, ItemOpeningBalance, WOR_DTL) => {
        if (!Array.isArray(mrnData) || !Array.isArray(miData) || !Array.isArray(ItemOpeningBalance) || !Array.isArray(WOR_DTL)) {
            console.error('Invalid data provided to groupAndSumData');
            return [];
        }

        const mrnGrouped = mrnData.reduce((acc, item) => {
            if (!acc[item.Item_cd]) {
                acc[item.Item_cd] = { Item_cd: item.Item_cd, totalAcceptedQty: 0 };
            }
            acc[item.Item_cd].totalAcceptedQty += item.Accepted_qty;
            return acc;
        }, {});

        const miGrouped = miData.reduce((acc, item) => {
            if (!acc[item.Item_code]) {
                acc[item.Item_code] = { Item_code: item.Item_code, totalIssueQty: 0 };
            }
            acc[item.Item_code].totalIssueQty += item.Issue_QTY;
            return acc;
        }, {});

        const balanceGrouped = ItemOpeningBalance.reduce((acc, item) => {
            if (!acc[item.item_code]) {
                acc[item.item_code] = { item_code: item.item_code, qty: 0 };
            }
            acc[item.item_code].qty += item.qty;
            return acc;
        }, {});

        const worGrouped = WOR_DTL.reduce((acc, item) => {
            if (!acc[item.Item_Code]) {
                acc[item.Item_Code] = { Item_Code: item.Item_Code, total_wo_qty: 0 };
            }
            acc[item.Item_Code].total_wo_qty += item.QTY;
            return acc;
        }, {});

        // 🔥 Collect all unique item codes
        const allItemCodes = new Set([
            ...Object.keys(mrnGrouped),
            ...Object.keys(miGrouped),
            ...Object.keys(balanceGrouped),
            ...Object.keys(worGrouped),
        ]);

        const mergedData = Array.from(allItemCodes).map((key) => {
            const mrnItem = mrnGrouped[key] || { totalAcceptedQty: 0 };
            const miItem = miGrouped[key] || { totalIssueQty: 0 };
            const balanceItem = balanceGrouped[key] || { qty: 0 };
            const worItem = worGrouped[key] || { total_wo_qty: 0 };

            const balanceStock = balanceItem.qty + mrnItem.totalAcceptedQty + worItem.total_wo_qty - miItem.totalIssueQty;

            return {
                Item_cd: key,
                openBalance: balanceItem.qty,
                materialRequest: mrnItem.totalAcceptedQty,
                materialIssue: miItem.totalIssueQty,
                wor_dtl_qty: worItem.total_wo_qty,
                balanceStock: balanceStock,
            };
        });

        return mergedData;
    };


    // Filter data based on the selected date range

    // const groupAndSumData = (mrnData, miData, ItemOpeningBalance, WOR_DTL) => {
    //     const allItemCodes = new Set([
    //         ...mrnData.map(item => item.Item_cd),
    //         ...miData.map(item => item.Item_code),
    //         ...ItemOpeningBalance.map(item => item.item_code),
    //         ...WOR_DTL.map(item => item.Item_Code),
    //     ]);

    //     const mrnGrouped = mrnData.reduce((acc, item) => {
    //         acc[item.Item_cd] = (acc[item.Item_cd] || 0) + item.Accepted_qty;
    //         return acc;
    //     }, {});

    //     const miGrouped = miData.reduce((acc, item) => {
    //         acc[item.Item_code] = (acc[item.Item_code] || 0) + item.Issue_QTY;
    //         return acc;
    //     }, {});

    //     const balanceGrouped = ItemOpeningBalance.reduce((acc, item) => {
    //         acc[item.item_code] = (acc[item.item_code] || 0) + item.qty;
    //         return acc;
    //     }, {});

    //     const worGrouped = WOR_DTL.reduce((acc, item) => {
    //         acc[item.Item_Code] = (acc[item.Item_Code] || 0) + item.QTY;
    //         return acc;
    //     }, {});

    //     const mergedData = Array.from(allItemCodes).map(code => {
    //         const openBalance = balanceGrouped[code] || 0;
    //         const materialRequest = mrnGrouped[code] || 0;
    //         const materialIssue = miGrouped[code] || 0;
    //         const worQty = worGrouped[code] || 0;

    //         const balanceStock = openBalance + materialRequest + worQty - materialIssue;

    //         return {
    //             Item_cd: code,
    //             openBalance,
    //             materialRequest,
    //             materialIssue,
    //             wor_dtl_qty: worQty,
    //             balanceStock
    //         };
    //     });

    //     return mergedData;
    // };



    const { mrnData, miData, ItemOpeningBalance, WOR_DTL } = filterByDateRange(data.MRN, data.MI, data.ItemOpeningBalance, data.WOR_DTL, fromDate, toDate);
    const groupedData = groupAndSumData(mrnData, miData, ItemOpeningBalance, WOR_DTL);

    // const filtered = filterByDateRange(data.MRN, data.MI, data.ItemOpeningBalance, data.WOR_DTL, fromDate, toDate);
    // const groupedData = groupAndSumData(
    //     filtered.mrnData,
    //     filtered.miData,
    //     filtered.ItemOpeningBalance,
    //     filtered.WOR_DTL
    // );

    // const [mainGroupOptions, setMainGroupOptions] = useState([]);
    // const [subGroupOptions, setSubGroupOptions] = useState([]);
    // const [selectedMainGroup, setSelectedMainGroup] = useState('');
    // const [selectedSubGroup, setSelectedSubGroup] = useState('');

    // useEffect(() => {
    //   const mainGroups = [...new Set(groupedData.map(d => d.Main_Group_Desc))];
    //   const subGroups = [...new Set(groupedData.map(d => d.Sub_Group_Desc))];

    //   setMainGroupOptions(mainGroups);
    //   setSubGroupOptions(subGroups);
    // }, [groupedData]);

    // const filteredData = groupedData.filter(item => {
    //   const mainMatch = selectedMainGroup ? item.Main_Group_Desc === selectedMainGroup : true;
    //   const subMatch = selectedSubGroup ? item.Sub_Group_Desc === selectedSubGroup : true;
    //   return mainMatch && subMatch;
    // });

    const [selectedMainGroup, setSelectedMainGroup] = useState(null);
    const [selectedSubGroup, setSelectedSubGroup] = useState(null);

    const [mainGroupOptions, setMainGroupOptions] = useState([]);
    const [subGroupOptions, setSubGroupOptions] = useState([]);

    useEffect(() => {
        const uniqueMainGroups = [...new Set(groupedData.map(d => d.Main_Group_Desc))].map(g => ({
            label: g,
            value: g
        }));

        // const uniqueSubGroups = [...new Set(groupedData.map(d => d.Sub_Group_Desc))].map(g => ({
        //     label: g,
        //     value: g
        // }));

        setMainGroupOptions(uniqueMainGroups);
        // setSubGroupOptions(uniqueSubGroups);
    }, [groupedData]);

    useEffect(() => {
        if (selectedMainGroup) {
            // Filter only subgroups where Main_Group_Desc matches selected
            const filtered = groupedData.filter(d => d.Main_Group_Desc === selectedMainGroup.value);

            const uniqueSubGroups = [...new Set(filtered.map(d => d.Sub_Group_Desc))].map(sg => ({
                label: sg,
                value: sg
            }));

            setSubGroupOptions(uniqueSubGroups);
        } else {
            // If no main group selected, show all subgroups
            const allSubGroups = [...new Set(groupedData.map(d => d.Sub_Group_Desc))].map(sg => ({
                label: sg,
                value: sg
            }));

            //setSubGroupOptions(allSubGroups);
        }

        // Also clear selectedSubGroup when main group changes
        //setSelectedSubGroup(null);
    }, [selectedMainGroup, groupedData]);


    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: 'transparent',
            borderColor: '#ccc',
        }),
    };

    const filteredData = groupedData.filter(item => {
        const mainMatch = selectedMainGroup ? item.Main_Group_Desc === selectedMainGroup.value : true;
        const subMatch = selectedSubGroup ? item.Sub_Group_Desc === selectedSubGroup.value : true;
        return mainMatch && subMatch;
    });


    //     const filteredData = groupedData.filter(item => {
    //         const mainMatch = selectedMainGroup
    //             ? item.Main_Group_Desc?.trim().toLowerCase() === selectedMainGroup.value.trim().toLowerCase()
    //             : true;
    //         const subMatch = selectedSubGroup
    //             ? item.Sub_Group_Desc?.trim().toLowerCase() === selectedSubGroup.value.trim().toLowerCase()
    //             : true;
    // //             console.log("Main:", item.Main_Group_Desc, "vs", selectedMainGroup?.value);
    // // console.log("Sub:", item.Sub_Group_Desc, "vs", selectedSubGroup?.value);

    //         return mainMatch && subMatch;

    //     });

    // console.log(filteredALLData)

    const handleExportFormatChange = (selectedOption) => {
        setExportFormat(selectedOption.value);
    };

    const [exportFormat, setExportFormat] = useState('pdf'); // Default is 'pdf'
    const [pdfLinkVisible, setPdfLinkVisible] = useState(false);
    const [companyDataName, setCompanyDataName] = useState([]);
    const [companyDataGST, setCompanyDataGST] = useState([]);
    useEffect(() => {
        const fetchCompanyData = async () => {
            try {
                const response = await axios.get('https://erpapi.emedha.in/pages/api/api/get-Company-data');
                setCompanyDataName(response.data[0].name);  // Set company data to state
                setCompanyDataGST(response.data[0].company_logo);
                setLoading(false);
            } catch (err) {
                setError('Error fetching company data');
                setLoading(false);
            }
        };

        fetchCompanyData();
    }, []);



    const styles = StyleSheet.create({
        page: {
            padding: 30,
            border: '1px solid black',
            fontSize: 7,

        },
        headerText: {
            textAlign: 'center',
            fontSize: 20,
            color: 'black',
            marginBottom: 20,
            fontWeight: 'bold',
        },
        dateRangeText: {
            fontSize: 12,
            marginBottom: 10,
            fontWeight: 'normal',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid black',
        },
        tableHeader: {
            backgroundColor: '#f5f5f5',
            borderTop: '1px solid black',
            borderBottom: '2px solid black',
            textAlign: 'center',
            padding: '5px 10px', // Reduced padding for smaller height
            fontWeight: '1000',
            fontSize: 8,
            borderLeft: '1px solid black',
            borderRight: '1px solid black',
        },
        tableCell: {
            padding: '10px 15px',
            textAlign: 'left',
            borderBottom: '1px solid black', // Lighter border for better contrast
            fontSize: 8,
            borderLeft: '1px solid black',
            borderRight: '1px solid black',
        },
        tableRow: {
            flexDirection: 'row',
            borderTop: '1px solid black',
            backgroundColor: '#fff',
        },
        tableRowAlt: {
            flexDirection: 'row',
            backgroundColor: '#f9f9f9', // Alternate row color for better readability
        },
        noDataText: {
            textAlign: 'center',
            fontSize: 10,
            color: 'red',
            marginTop: 20,
        },
        dateRangeText1: {
            width: '50%',
            fontSize: 12,
            textAlign: 'left',
            fontWeight: 'bold',
        },
        dateRangeText2: {
            width: '50%',
            marginBottom: 10,
            textAlign: 'right',
            fontSize: 12,
            fontWeight: 'bold',
        },
        companyInfoContainer: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 20,
        },
        companyName: {
            fontSize: 12,
            fontWeight: 'bold',
            color: 'blue',
            width: '50%',
            textAlign: 'left',
        },
        gstNumber: {
            fontSize: 12,
            color: 'blue',
            width: '100%',
            marginBottom: 10,
            textAlign: 'right',
        },
        image: {
            width: 'auto',
            height: 35,
            marginBottom: 20,
        },
    });




    // const MyDocument = ({ groupedData, fromDate, toDate, companyDataName,itemms, openBalanceData,companyDataGST }) => (
    //     <Document>
    //         <Page style={styles.page}>
    //             <View style={styles.companyInfoContainer}>
    //                 <Image style={styles.image} src={companyDataGST} />
    //                 <Text style={styles.gstNumber}>{companyDataName}</Text>
    //             </View>

    //             <Text style={styles.headerText}>Stock Report</Text>

    //             <View style={{ flexDirection: 'row', marginBottom: 10 }}>
    //                 <Text style={styles.dateRangeText1}>
    //                     From Date: {fromDate ? fromDate.toLocaleDateString() : 'N/A'}
    //                 </Text>
    //                 <Text style={styles.dateRangeText2}>
    //                     To Date: {toDate ? toDate.toLocaleDateString() : 'N/A'}
    //                 </Text>
    //             </View>

    //             {/* Table */}
    //             <View style={styles.table}>
    //                 {/* Table Header */}
    //                 <View style={styles.tableRow}>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>SL_No</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>Item Code</Text>
    //                     <Text style={[styles.tableHeader, { width: '25%' }]}>Item Desc</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>Item UOM</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>Open Bal</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>Material Receipt</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}> Wo_od QTY</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>Material Issue</Text>
    //                     <Text style={[styles.tableHeader, { width: '12%' }]}>Bal_Stq</Text>

    //                 </View>

    //                 {/* {groupedData && groupedData.length > 0 ? (
    //                     groupedData.map((item, index) => {
    //                         const matchedItem = itemms.find(i => i.itemCd === item.Item_cd); */}
    //                 {groupedData.map((item, index) => {
    //                     const matchedItem = itemms.find(i => i.itemCd === item.Item_cd);

    //                     // Match with openBalanceData based on item_cd and date range
    //                     const matchingBalance = openBalanceData.find(ob => {
    //                         const itemCodeMatch = ob.item_cd === item.Item_cd;

    //                         const fromMatch = new Date(ob.from_date).getMonth() === fromDate.getMonth() &&
    //                             new Date(ob.from_date).getFullYear() === fromDate.getFullYear();

    //                         const toMatch = new Date(ob.to_date).getMonth() === toDate.getMonth() &&
    //                             new Date(ob.to_date).getFullYear() === toDate.getFullYear();

    //                         return itemCodeMatch && fromMatch && toMatch;
    //                     });

    //                     return (
    //                         <View style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlt} key={index}>
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{index + 1}</Text>
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{item.Item_cd}</Text>
    //                             <Text style={[styles.tableCell, { width: '25%' }]}>{matchedItem ? matchedItem.itemDesc : 'Item not found'}</Text>
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{matchedItem ? matchedItem.itemUOM : 'Item not found'}</Text>
    //                             {/* <Text style={[styles.tableCell, { width: '12%' }]}>{item.openBalance}</Text> */}
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{matchingBalance ? matchingBalance.total_open_balance : '-'}</Text>
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{item.materialRequest}</Text>
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{item.wor_dtl_qty}</Text>
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>{item.materialIssue}</Text>
    //                             {/* <Text style={[styles.tableCell, { width: '12%' }]}>{item.balanceStock}</Text> */}
    //                             <Text style={[styles.tableCell, { width: '12%' }]}>
    //                                 {(() => {
    //                                     const openBal = matchingBalance ? Number(matchingBalance.total_open_balance) : 0;
    //                                     const req = Number(item.materialRequest) || 0;
    //                                     const worQty = Number(item.wor_dtl_qty) || 0;
    //                                     const issue = Number(item.materialIssue) || 0;

    //                                     const sum = openBal + req + worQty;
    //                                     const finalBal = sum - issue;

    //                                     return `${finalBal}`;
    //                                 })()}
    //                             </Text>

    //                         </View>
    //                     );
    //                 })}
    //             </View>
    //         </Page>
    //     </Document>
    // );

    const rowsPerPage = 10;
    const paginateData = (data, rowsPerPage) => {
        const pages = [];
        for (let i = 0; i < data.length; i += rowsPerPage) {
            pages.push(data.slice(i, i + rowsPerPage));
        }
        return pages;
    };

    const MyDocument = ({ filteredData, fromDate, toDate, companyDataName, itemms, openBalanceData, companyDataGST , selectedMainGroup, selectedSubGroup}) => {
        const paginatedData = paginateData(filteredData, rowsPerPage);

        return (
            <Document>
                {paginatedData.map((pageData, pageIndex) => (
                    <Page key={pageIndex} size="A4" style={styles.page}>
                        {/* Company Header */}
                        <View style={styles.companyInfoContainer}>
                            <Image style={styles.image} src={companyDataGST} />
                            <Text style={styles.gstNumber}>{companyDataName}</Text>
                        </View>

                        <Text style={styles.headerText}>Stock Report</Text>

                        {/* Date Range */}
                        <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                            <Text style={styles.dateRangeText1}>
                                From Date: {fromDate?.toLocaleDateString() ?? 'N/A'}
                            </Text>
                            <Text style={styles.dateRangeText2}>
                                To Date: {toDate?.toLocaleDateString() ?? 'N/A'}
                            </Text>
                        </View>

                        {/* Selected Filters */}
                        <View style={{ flexDirection: 'row', marginBottom: 10 }}>
                            <Text style={styles.dateRangeText1}>
                                Main Group: {selectedMainGroup ?? 'All'}
                            </Text>
                            <Text style={styles.dateRangeText2}>
                                Sub Group: {selectedSubGroup ?? 'All'}
                            </Text>
                        </View>


                        {/* Table Header */}
                        <View style={styles.tableRow}>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>SL_No</Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>Item Code</Text>
                            <Text style={[styles.tableHeader, { width: '30%' }]}>Item Desc</Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>Item UOM</Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>Open </Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>MRN</Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>WO Qty</Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>Issue</Text>
                            <Text style={[styles.tableHeader, { width: '12%' }]}>Closing</Text>
                        </View>

                        {/* Table Rows */}
                        {pageData.map((item, rowIndex) => {
                            const matchedItem = itemms.find(i => i.itemCd === item.Item_cd);

                            const matchingBalance = openBalanceData.find(ob => {
                                const itemCodeMatch = ob.item_cd === item.Item_cd;
                                const fromMatch =
                                    new Date(ob.from_date).getMonth() === fromDate.getMonth() &&
                                    new Date(ob.from_date).getFullYear() === fromDate.getFullYear();
                                const toMatch =
                                    new Date(ob.to_date).getMonth() === toDate.getMonth() &&
                                    new Date(ob.to_date).getFullYear() === toDate.getFullYear();
                                return itemCodeMatch && fromMatch && toMatch;
                            });

                            const openBal = matchingBalance ? Number(matchingBalance.total_open_balance) : 0;
                            const req = Number(item.materialRequest) || 0;
                            const worQty = Number(item.wor_dtl_qty) || 0;
                            const issue = Number(item.materialIssue) || 0;
                            const finalBal = openBal + req + worQty - issue;

                            return (
                                <View
                                    style={rowIndex % 2 === 0 ? styles.tableRow : styles.tableRowAlt}
                                    key={rowIndex}
                                >
                                    <Text style={[styles.tableCell, { width: '12%' }]}>{rowIndex + 1 + pageIndex * rowsPerPage}</Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>{item.Item_cd}</Text>
                                    <Text style={[styles.tableCell, { width: '30%' }]}>
                                        {matchedItem ? matchedItem.itemDesc : 'Item not found'}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>
                                        {matchedItem ? matchedItem.itemUOM : 'Item not found'}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>
                                        {matchingBalance ? matchingBalance.total_open_balance : '-'}
                                    </Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>{item.materialRequest}</Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>{item.wor_dtl_qty}</Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>{item.materialIssue}</Text>
                                    <Text style={[styles.tableCell, { width: '12%' }]}>{finalBal}</Text>
                                </View>
                            );
                        })}
                    </Page>
                ))}
            </Document>
        );
    };




    const handlePrint = () => {
        // Check if the groupedData is valid
        console.log(groupedData); // Add this log to check the data

        //const data = groupedData; // Make sure the correct data is passed
        const data = filteredData;

        if (exportFormat === 'pdf') {
            // Generating the PDF document
            const doc = <MyDocument filteredData={data}  selectedMainGroup={selectedMainGroup?.label}
            selectedSubGroup={selectedSubGroup?.label} companyDataName={companyDataName} companyDataGST={companyDataGST} fromDate={fromDate} toDate={toDate} openBalanceData={openBalanceData} itemms={itemms} />;

            // Generate the PDF as a Blob and trigger download
            pdf(doc).toBlob().then((blob) => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'Stock.pdf'; // Set the file name for the downloaded PDF
                link.click(); // Trigger the download
            });

        } else if (exportFormat === 'excel') {
            handleExportToExcel();
        }
    };
    // const handleExportToExcel = () => {
    //     // Ensure filteredALLData is defined and contains data
    //     const data = filteredData;



    //     if (!data || data.length === 0) {
    //         console.error("No data available to export.");
    //         return;
    //     }

    //     // Prepare the worksheet data with a header row
    //     const wsData = [
    //         ['Item Code', 'Open Balance', 'Material Request', 'Material Issue', 'Balance Stock',],
    //         ...data.map(item => [
    //             item.Item_cd || '0',  // PO_NO (fallback to empty if missing)
    //             item.openBalance || '0',  // Supplier CD

    //             item.materialRequest || '0',  // Item Code
    //             item.materialIssue || '0',  // Item Description
    //             item.balanceStock || '0',  // Unit of Measure

    //         ]),

    //     ];

    //     // Log the worksheet data for debugging
    //     console.log("Worksheet Data:", wsData);

    //     // Create worksheet from array of arrays
    //     const ws = XLSX.utils.aoa_to_sheet(wsData);

    //     // Create a new workbook and append the worksheet to it
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Data');

    //     // Write the Excel file to disk
    //     XLSX.writeFile(wb, 'table.xlsx');
    // };

    const handleExportToExcel = () => {
        const data = groupedData.filter(item => {
            const mainMatch = selectedMainGroup ? item.Main_Group_Desc === selectedMainGroup.value : true;
            const subMatch = selectedSubGroup ? item.Sub_Group_Desc === selectedSubGroup.value : true;
            return mainMatch && subMatch;
        });
    
        if (!data || data.length === 0) {
            console.error("No data available to export.");
            return;
        }
    
        const wsData = [
            ['Sl No', 'Item Code', 'Item Desc', 'UOM', 'Open Balance', 'Material Receipt', 'WO Qty', 'Material Issue', 'Balance Stock'],
            ...data.map((item, index) => {
                const matchedItem = itemms.find(i => i.itemCd === item.Item_cd);
                const matchingBalance = openBalanceData.find(ob => {
                    const itemCodeMatch = ob.item_cd === item.Item_cd;
                    const fromMatch = new Date(ob.from_date).getMonth() === fromDate.getMonth() &&
                        new Date(ob.from_date).getFullYear() === fromDate.getFullYear();
                    const toMatch = new Date(ob.to_date).getMonth() === toDate.getMonth() &&
                        new Date(ob.to_date).getFullYear() === toDate.getFullYear();
                    return itemCodeMatch && fromMatch && toMatch;
                });
    
                const openBal = matchingBalance ? Number(matchingBalance.total_open_balance) : 0;
                const req = Number(item.materialRequest) || 0;
                const worQty = Number(item.wor_dtl_qty) || 0;
                const issue = Number(item.materialIssue) || 0;
                const finalBal = openBal + req + worQty - issue;
    
                return [
                    index + 1,
                    item.Item_cd || '',
                    matchedItem?.itemDesc || '',
                    matchedItem?.itemUOM || '',
                    openBal,
                    req,
                    worQty,
                    issue,
                    finalBal
                ];
            })
        ];
    
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Stock Report');
        XLSX.writeFile(wb, 'Stock_Report.xlsx');
    };
    

    return (

        <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={A1} alt="item" style={{ width: "20%" }} />
                <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>STOCK BALANCE</h1>
                <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",

                    }} title='Print'>
                        <IoPrint onClick={handlePrint} size={30} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        // cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        // opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30}
                            onClick={handleBack}
                        // onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                        />
                    </div>
                </div>
            </div>
            <hr />

            <>
                <Container>

                    <Row className="mt-4">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>From Date</Form.Label>
                                <DatePicker
                                    style={{ backgroundColor: '#ffffff' }}
                                    selected={fromDate}
                                    onChange={setFromDate}
                                    placeholderText="From Date"
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control  custom-datepicker"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>To Date</Form.Label>
                                <DatePicker

                                    selected={toDate}
                                    onChange={setToDate}
                                    placeholderText="To Date"
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control custom-datepicker"

                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>

                                <Select
                                    options={[
                                        { label: 'PDF', value: 'pdf' },
                                        { label: 'Excel', value: 'excel' }
                                    ]}
                                    onChange={handleExportFormatChange}
                                    defaultValue={{ label: 'PDF', value: 'pdf' }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: 'transparent',
                                            borderColor: '#ccc', // Optional: change border color if needed
                                        }),

                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <div style={{ display: 'flex', gap: '1rem', marginTop: '10px', marginBottom: '1rem' }}>
                            {/* <select value={selectedMainGroup} onChange={e => setSelectedMainGroup(e.target.value)}>
          <option value="">All Main Groups</option>
          {mainGroupOptions.map(group => (
            <option key={group} value={group}>{group}</option>
          ))}
        </select>

        <select value={selectedSubGroup} onChange={e => setSelectedSubGroup(e.target.value)}>
          <option value="">All Sub Groups</option>
          {subGroupOptions.map(group => (
            <option key={group} value={group}>{group}</option>
          ))}
        </select> */}
                            {/* <Col md={4}>
                                <Select
                                    options={mainGroupOptions}
                                    value={selectedMainGroup}
                                    onChange={setSelectedMainGroup}
                                    placeholder="Select Main Group"
                                    isClearable
                                    styles={customSelectStyles}
                                />

                            </Col>
                            <Col md={4}>
                                <Select
                                    options={subGroupOptions}
                                    value={selectedSubGroup}
                                    onChange={setSelectedSubGroup}
                                    placeholder="Select Sub Group"
                                    isClearable
                                    styles={customSelectStyles}
                                />

                            </Col> */}
                            <Col md={4}>
    <Select
        options={mainGroupOptions}
        value={selectedMainGroup}
        onChange={(selected) => {
            setSelectedMainGroup(selected);
            setSelectedSubGroup(null); // Clear sub group when main group is changed or cleared
        }}
        placeholder="Select Main Group"
        isClearable
        styles={customSelectStyles}
    />
</Col>

{/* Show Sub Group only if Main Group is selected */}
{selectedMainGroup && (
    <Col md={4}>
        <Select
            options={subGroupOptions}
            value={selectedSubGroup}
            onChange={setSelectedSubGroup}
            placeholder="Select Sub Group"
            isClearable
            styles={customSelectStyles}
        />
    </Col>
)}

                        </div>

                    </Row>
                    <Row className="mt-4">
                        <Col>

                            <div>

                                <Table striped bordered hover>
                                    <thead>
                                        <tr> <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>ID</th>


                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item Code</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item Desc</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Item UOM</th>
                                            {/* <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>GroupID</th> */}
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Group_Des</th>
                                            {/* <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Sub GroupID</th> */}
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Sub Group_Des</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Open</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>MRN </th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Work OrderQTY</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Issues</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', backgroundColor: '#ffffff' }}>Closing</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.map((item, index) => {
                                            const matchedItem = itemms.find(i => i.itemCd === item.Item_cd);

                                            // Match with openBalanceData based on item_cd and date range
                                            const matchingBalance = openBalanceData.find(ob => {
                                                const itemCodeMatch = ob.item_cd === item.Item_cd;

                                                const fromMatch = new Date(ob.from_date).getMonth() === fromDate.getMonth() &&
                                                    new Date(ob.from_date).getFullYear() === fromDate.getFullYear();

                                                const toMatch = new Date(ob.to_date).getMonth() === toDate.getMonth() &&
                                                    new Date(ob.to_date).getFullYear() === toDate.getFullYear();

                                                return itemCodeMatch && fromMatch && toMatch;
                                            });

                                            return (
                                                <tr key={item.Item_cd}>
                                                    <td className="text-center" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{index + 1}</td>
                                                    <td className="text-center" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.Item_cd}</td>
                                                    <td className="text-left" style={{ minWidth: '150px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{matchedItem ? matchedItem.itemDesc : 'Item not found'}</td>
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{matchedItem ? matchedItem.itemUOM : 'Item not found'}</td>
                                                    {/* <td className="text-center" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.Main_Group_CD}</td> */}
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.Main_Group_Desc}</td>
                                                    {/* <td className="text-center" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.Sub_Group_CD}</td> */}
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.Sub_Group_Desc}</td>
                                                    {/* <td className="text-center" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.openBalance}</td> */}
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{matchingBalance ? matchingBalance.total_open_balance : '-'}</td>
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.materialRequest}</td>
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.wor_dtl_qty}</td>
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>{item.materialIssue}</td>
                                                    <td className="text-left" style={{ minWidth: '90px', border: '1px solid black', padding: '8px', backgroundColor: '#ffffff' }}>
                                                        {(() => {
                                                            const openBal = matchingBalance ? Number(matchingBalance.total_open_balance) : 0;
                                                            const req = Number(item.materialRequest) || 0;
                                                            const worQty = Number(item.wor_dtl_qty) || 0;
                                                            const issue = Number(item.materialIssue) || 0;

                                                            const sum = openBal + req + worQty;
                                                            const finalBal = sum - issue;

                                                            return `${finalBal}`;
                                                        })()}
                                                    </td>




                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>


                        </Col>
                    </Row>

                    <Row>


                    </Row>

                </Container>
            </>



        </div>
    );
};

export default Stock;

